import { Component } from 'react'
import { Redirect, Route, Router } from 'react-router-dom'
import { t } from 'ttag'



import { NoHeaderRouter } from '@h2/noHeaderRouter'
import { Router as UiRouter } from '@h2/router'

import { browserHistory } from './util/browserHistory'
import ParentPortal from './containers/ParentPortal'
import ParentRequest from './containers/ParentRequest'
import { EarlyLoader } from './containers/early/EarlyLoader'
import TitleWrap from './containers/TitleWrap'
import RequireSignIn from './components/RequireSignIn'
import MustAssociate from './containers/MustAssociate'
import WIPPanel from './containers/assessment/WIPPanel'
import SkillsPanel from './containers/assessment/SkillsPanel'
import { AuthRoutes } from './containers/authentication/authRoutes'
import AboutRoutes from './containers/about/AboutRoutes'
import EducatorRoutes from './containers/educators/EducatorRoutes'
import HelpRoutes from './containers/help/HelpRoutes'
import MilitaryRoutes from './containers/military/MilitaryRoutes'
import LazyRoute from './components/LazyRoute'
import OccupationRoutes from './containers/occupations/OccupationRoutes'
import Search from './containers/Search'
import WorkImportanceProfilerResults from './containers/assessment/wip/WorkImportanceProfilerResults'
import WorkKeysResults from './containers/assessment/workkeys/WorkKeysResults'
import SkillsProfilerResults from './containers/assessment/sp/SkillsProfilerResults'
import { SkillsDecoderResults } from './containers/assessment/skills/SkillsDecoderResults'






export default class Routes extends Component {
  constructor() {

    super()
    browserHistory.listen(location => {
      window.scrollTo(0, 0)
      window.ga?.('set', 'page', location.pathname + location.search)
      window.ga?.('send', 'pageview')
      window.h2?.clearNotices()
    })

  }

  render() {


    return (
      <Router history={browserHistory}>
        <TitleWrap>
          <Route path="/index">
            <Redirect to="/" />
          </Route>
          <Route path="/early/game/:gameId">
            <EarlyLoader />
          </Route>
          <Route path="/myaccount/files/">
            <Redirect to="/personalprofile/files" />
          </Route>
          <Route path="/parent">
            <RequireSignIn name={t`Parent Portal`}>
              <ParentPortal />
            </RequireSignIn>
          </Route>
          <Route path="/r/:code">
            <RequireSignIn name={t`Accept Request`}>
              <ParentRequest />
            </RequireSignIn>
          </Route>
          <Route path="/search" component={Search} exact />
          <Route path="/wip/results" component={WorkImportanceProfilerResults} />
          <Route path="/workkeys/results" component={WorkKeysResults} />
          <Route path="/skills/results" component={SkillsProfilerResults} />
          <Route path="/skillsdecoder/results" exact component={SkillsDecoderResults} />
          <Route path="/wip" exact>
            <MustAssociate pageTitle={t`Work Importance Profiler`}>
              <WIPPanel />
            </MustAssociate>
          </Route>
          <Route path="/skills" exact>
            <MustAssociate pageTitle>
              <SkillsPanel />
            </MustAssociate>
          </Route>
          <AuthRoutes />
          <AboutRoutes />
          <EducatorRoutes />
          <HelpRoutes />
          <MilitaryRoutes />
          <OccupationRoutes />
          <LazyRoute
            path="/admin"
            component={() =>
              import(/* webpackChunkName: "admin" */ './containers/admin/AdminRoutes')}
          />
          <LazyRoute
            path="/budget"
            component={() =>
              import(/* webpackChunkName: "budget" */ './containers/budget/BudgetRoutes')}
          />
          <LazyRoute
            path="/cap"
            component={() =>
              import(/* webpackChunkName: "cap" */ './containers/cap/CapRoutes')}
          />
          <LazyRoute
            path="/employers"
            component={() =>
              import(
                /* webpackChunkName: "employers" */ './containers/employers/EmployerPortal'
              )}
          />
          <LazyRoute
            path="/ip"
            component={() =>
              import(
                /* webpackChunkName: "ip" */ './containers/assessment/ip/InterestProfilerRoutes'
              )}
          />
          <LazyRoute
            path="/industry"
            component={() =>
              import(
                /* webpackChunkName: "industry" */ './containers/industry/IndustryRoutes'
              )}
          />
          <LazyRoute
            path="/info/webinars"
            component={() =>
              import(/* webpackChunkName: "webinars" */ './containers/WebinarForm')}
          />
          <LazyRoute
            path="/jobs"
            component={() =>
              import(/* webpackChunkName: "jobs" */ './containers/jobs/JobRoutes')}
          />
          <LazyRoute
            path="/jobtools"
            component={() =>
              import(
                /* webpackChunkName: "jobtools" */ './containers/jobtools/JobToolRoutes'
              )}
          />
          <LazyRoute
            path="/library"
            component={() =>
              import(
                /* webpackChunkName: "library" */ './containers/library/LibraryRoutes'
              )}
          />
          <LazyRoute
            path="/localopportunities"
            component={() =>
              import(
                /* webpackChunkName: "localopportunities" */ './containers/localopportunities/LocalOpportunitiesRoutes'
              )}
          />
          <LazyRoute
            path="/personalprofile"
            component={() =>
              import(
                /* webpackChunkName: "personalprofile" */ './containers/user/PersonalProfileRoutes'
              )}
          />
          <LazyRoute
            path="/planning/courses"
            component={() =>
              import(
                /* webpackChunkName: "courses" */ './containers/courses/CoursePlanRoutes'
              )}
          />
          <LazyRoute
            path="/profiles"
            component={() =>
              import(
                /* webpackChunkName: "profiles" */ './containers/profile/ProfileRoutes'
              )}
          />
          <LazyRoute
            path="/quick"
            exact
            component={() =>
              import(/* webpackChunkName: "quick" */ './containers/QuickAssessment')}
          />
          <LazyRoute
            path="/quick/:riasec"
            component={() =>
              import(
                /* webpackChunkName: "quickriasec" */ './containers/occupations/RiasecListing'
              )}
          />
          <LazyRoute
            path="/rep"
            component={() =>
              import(/* webpackChunkName: "rep" */ './containers/ReportRoutes')}
          />
          <LazyRoute
            path="/review/file/:reviewId"
            component={() =>
              import(/* webpackChunkName: "review" */ './containers/review/FileReview')}
          />
          <LazyRoute
            path="/survey/:surveyId"
            component={() =>
              import(/* webpackChunkName: "survey" */ './containers/SystemSurvey')}
          />
          <LazyRoute
            path="/internal"
            component={() =>
              import(
                /* webpackChunkName: "internal" */ './containers/internal/InternalRoutes'
              )}
          />
          <LazyRoute
            path="/connect"
            component={() =>
              import(
                /* webpackChunkName: "connectSearch" */ './containers/profile/ConnectSearchView'
              )}
          />
          <LazyRoute
            path="/info/nevada/districts"
            component={() =>
              import(
                /* webpackChunkName: "connectSearch" */ './customizations/nevada/components/SelectLibraryDistrict'
              )}
          />
        </TitleWrap>

        <NoHeaderRouter />
        <UiRouter />
      </Router>
    )
  }
}

export { browserHistory }
export const reactRouteHandler = url => event => {
  if (
    event.ctrlKey ||
    event.shiftKey ||
    // apple
    event.metaKey ||
    // middle click, >IE9 + everyone else
    (event.button && event.button === 1)
  ) {
    return
  }

  const isReactRendered = !!document.getElementById('spatarget')

  if (isReactRendered) {
    event.preventDefault()
    const newUrl = url ?? event.currentTarget?.getAttribute('href')

    /*
     * The test below looks to see if the site requires a login and whether the user is logged in. If so,
     * it will intercept the call to / and replace it with a call to the login page. Without it, users were getting
     * put to a non-functional homepage if they navigated via the route instead of a refresh.
     */
    browserHistory.push(
      newUrl === '/' && dynamicValues.requireAuthentication && !dynamicValues.userProfile
        ? '/signin'
        : newUrl
    )
  }
}

window.reactRouteHandler = reactRouteHandler

export const logError = callback => error => {

  callback && callback()
}
